/* eslint-disable no-undef */

import React, { memo, useContext, useEffect, useRef, useState } from 'react';

import { AiOutlineClose } from 'react-icons/ai';
import { ChatgptContext } from './context_chatgpt/ChatgptContext';
import { buildChartContext, getFreshChartAnswer } from './utils';
import { streamAzureResponse } from './azureResponses';
import { renderMarkdown } from './renderMarkdown';
import Dialog from '../common/Dialog';
import Draggable from 'react-draggable';
import { GoLinkExternal } from 'react-icons/go';
import { LoaderBoxes } from '../modules/App/LayoutComponents/Loader/Loader';
import SummaryDialog from '../common/SummaryDialog';
import { useNavigate } from 'react-router-dom';

// Icon from react-icons

const systemMessage = {
  role: 'assistant',
  content:
    'Summarize the provided data and create concise summaries or key points.',
};

const ChatgptSummary = () => {
  const {
    setSidebarStatus,
    sidebarStatus,
    summaryStatus,
    setSummaryStatus,
    ChatgptData,
    setconvoId,
    PillsName,
    socialMediaType,
    mainSearchTerm,
    subtype,
    SearchObject,
  } = useContext(ChatgptContext);

  const [lang, setlang] = useState('');
  // listning with user mic
  const [modal, setmodal] = useState(false);

  const [summary, setSummary] = useState([]);
  const [prompt, setPrompt] = useState('');
  const [isPromptData, setIsPromptData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const abortRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    // The env var isn't set in every environment; without a fallback the
    // request used to start with the literal word "undefined".
    setPrompt(
      process.env.REACT_APP_CHATGPT_SUMMARIZE_PROMPT ||
        'Summarize this data in a few key insights.',
    );
    return () => {
      setconvoId('');
    };
  }, []);

  useEffect(() => {
    if (ChatgptData?.title) {
      handleFeedBtn();
    }
  }, [ChatgptData]);

  useEffect(() => {
    setSummary([]);
    setErrorMessage('');
  }, [socialMediaType, ChatgptData]);

  useEffect(() => {
    if (!summaryStatus) abortRef.current?.abort();
  }, [summaryStatus]);

  const handleSummarizeBtn = () => {
    setPrompt(`${process.env.REACT_APP_CHATGPT_SUMMARIZE_PROMPT}`);
    setSidebarStatus(false);
    setconvoId('');
  };

  // Streams the summary from Azure AI Foundry (gpt-5.4-nano). The key is
  // REACT_APP_QUICK_SUMMARY_API_KEY, set in .env (it is also what the
  // "Public LLM" model option in the other AI panels uses).
  async function feedToChatGPT(theJsonData) {
    // A newer chart (or a Regenerate) supersedes a stream still in flight, so
    // two streams can't interleave into the same panel.
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;
    setErrorMessage('');

    try {
      const { text } = await streamAzureResponse({
        apiKey: process.env.REACT_APP_QUICK_SUMMARY_API_KEY,
        instructions: systemMessage.content,
        input: `${
          lang ? `In ${lang} ${prompt}` : prompt
        } \n. ${JSON.stringify(theJsonData)}`,
        signal: controller.signal,
        onDelta: (partial) => {
          setIsLoading(false);
          setSummary([{ user: prompt, content: partial }]);
        },
      });
      setSummary([{ user: prompt, content: text }]);
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('Quick Summary failed:', error);
      setSummary([]);
      setErrorMessage(
        error?.code === 'missing-api-key'
          ? "Quick Summary isn't configured on this environment yet (missing API key)."
          : error?.status === 401 || error?.status === 403
          ? "Quick Summary couldn't sign in to the AI service. Please contact support."
          : "Quick Summary couldn't be generated right now. Please try again in a moment.",
      );
    } finally {
      if (abortRef.current === controller) setIsLoading(false);
    }
  }

  useEffect(() => {
    if (prompt?.length > 0) {
      setIsPromptData(true);
    } else {
      setIsPromptData(false);
    }
  }, [prompt]);

  const handleFeedBtn = async () => {
    setIsLoading(true);
    if (ChatgptData != null && summaryStatus) {
      // Check for a saved answer before paying to run the agent again - a
      // saved answer counts regardless of which model produced it.
      const chartName = PillsName || ChatgptData?.title;
      const saved = await getFreshChartAnswer({
        chartName,
        context: buildChartContext({
          handlerUsed: mainSearchTerm,
          socialMediaType,
          searchObject: SearchObject,
        }),
      });
      if (saved) {
        setSummary((prev) => [
          ...prev,
          { user: prompt, content: saved.summary, token: 0, cached: true, savedAt: saved.date },
        ]);
        setIsLoading(false);
        return;
      }
      await feedToChatGPT(ChatgptData.excelData.slice(0, 40));
    }
  };

  // "Regenerate" on a saved answer - skips the fresh-answer check above and
  // runs the chart's agent again.
  const handleRegenerate = async () => {
    if (!ChatgptData?.excelData?.length) return;
    setIsLoading(true);
    await feedToChatGPT(ChatgptData.excelData.slice(0, 40));
    setIsLoading(false);
  };

  const overlayStyle = {
    backgroundColor: 'transparent',
    backdropFilter: 'none',
    zIndex: 40, // Set the overlay background color to transparent
  };

  return (
    // <ReactModal
    //   initWidth={700}
    //   intiHeight={400}
    //   isOpen={summaryStatus}
    //   onRequestClose={() => setSidebarStatus(false)}
    //   disableResize={false}
    //   customStyles={{
    //     overlay: overlayStyle,
    //   }}
    // >
    //   <div className="w-full h-full flex flex-col gap-2">
    //     <p className="text-[20px] text-black font-medium text-center pt-2">
    //       Summary By Omnio AI
    //     </p>
    //     <div className="w-full flex  items-center justify-between px-5 py-4 border-b-[1.5px] border-gray-400">
    //       <p className="text-[20px] font-medium">
    //         {ChatgptData &&
    //           mainSearchTerm?.toUpperCase() +
    //             ': ' +
    //             (socialMediaType !== undefined ? socialMediaType : '') +
    //             (subtype === 'userposts' || subtype === 'manual_users'
    //               ? ' User Account '
    //               : subtype === 'userhashtags' || subtype === 'manual_hashtags'
    //               ? ' User Hashtag '
    //               : subtype === 'manual_tags'
    //               ? ' User Tag '
    //               : subtype === 'keywordposts'
    //               ? ' Keywords '
    //               : '') +
    //             (subtype ? ' - ' : '') +
    //             (ChatgptData.title !== undefined
    //               ? ' "' + ChatgptData.title + '" '
    //               : '') +
    //             ' data - "' +
    //             (SearchObject.updatedDays || SearchObject.days) +
    //             ' days' +
    //             '"' +
    //             (SearchObject.interval !== undefined
    //               ? ' by ' + SearchObject.interval
    //               : '')}
    //       </p>
    //       {/* <div className="flex justify-center items-center"> */}
    //       {/* <button title="Disclaimer" onClick={() => setmodal(true)}>
    //           <FcDisclaimer className="text-lg" />
    //         </button> */}
    //       {/* <button
    //         title="Open Chat History in omniO AI Assistant Page"
    //         alt="Default Prompt"
    //         className="w-[30px] h-[30px] rounded-full flex items-center justify-center mx-2"
    //         onClick={() => {
    //           navigate('/haix-genai/summary', {
    //             state: {
    //               message: summary,
    //               pillname: ChatgptData?.title,
    //               socialMediaType,
    //               handler: mainSearchTerm,
    //               ChatgptData,
    //               chartData: ChatgptData.excelData.slice(0, 40),
    //             },
    //           });
    //           setSummaryStatus(false);
    //           handleSummarizeBtn();
    //         }}
    //       >
    //         <GoLinkExternal className="text-[16px] text-green-600" />
    //       </button> */}
    //       <button
    //         title="Close"
    //         onClick={() => setSummaryStatus(false)}
    //         className="mx-4"
    //       >
    //         <AiOutlineClose color="#ff0000" />
    //       </button>
    //       {/* </div> */}
    //     </div>
    //     <div className="overflow-x-auto h-auto">
    //       {!isLoading &&
    //         summary.reverse().map((line, index) => {
    //           return (
    //             <div key={index} className="border-b-2 my-2 mx-4">
    //               <div className="mt-2">
    //                 <span className="font-bold">
    //                   Summary by omniO AI Assistant:{' '}
    //                 </span>
    //               </div>
    //               {line?.content?.split('\n').map((item, index) => (
    //                 <div key={index}>
    //                   <p>{item}</p>
    //                   <br />
    //                 </div>
    //               ))}
    //             </div>
    //           );
    //         })}
    //       {isLoading && <LoaderBoxes message="Fetching" />}
    //     </div>
    //     <div className="mx-4 my-2 flex items-center">
    //       For more details Analysis -
    //       <button
    //         title="Open Chat History in omniO AI Assistant"
    //         onClick={() => {
    //           setSidebarStatus(true);
    //           setSummaryStatus(false);
    //         }}
    //         className="underline text-secondary bottom-0"
    //       >
    //         <GoLinkExternal className="text-[16px] text-green-600" />
    //       </button>
    //     </div>
    //   </div>
    //   {showModal && (
    //     <Dialog
    //       title={ModalTitle}
    //       body={showModalMessage}
    //       positiveButton1={{
    //         text: 'Ok',
    //         callback: () => {},
    //       }}
    //       showDialog={showModal}
    //       setShowDialog={setshowModal}
    //     />
    //   )}
    // </ReactModal>
    <Draggable>
      {/* <Modal
        isOpen={this.props.isModalOpen}
        toggle={this.props.toggleModal}
        className="gray-header-modal md"
      >
        <ModalHeader>
          <label className="modal-header-title text-dark">Modal Title</label>
          <img
            src="/images/close.png"
            alt="close"
            width="20px"
            className="closeIcon"
            onClick={this.props.toggleModal}
          />
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>// Modal body</Col>
          </Row>
        </ModalBody>
      </Modal> */}
      <SummaryDialog
        title=""
        body=""
        positiveButton1={{
          text: 'Close',
          callback: () => {},
        }}
        showDialog={summaryStatus}
        setShowDialog={setSummaryStatus}
      >
        <div className="w-full h-full flex  flex-col gap-2">
          <p className="text-[20px] text-black font-medium text-center ">
            Summary By omniO AI
          </p>
          <div className="w-full flex  items-center justify-between px-5 py-4 border-b-[1.5px] border-gray-400">
            <p className="text-[20px] font-medium">
              {ChatgptData &&
                mainSearchTerm?.toUpperCase() +
                  ': ' +
                  (Array.isArray(socialMediaType)
                    ? socialMediaType
                        .map(
                          (item) =>
                            item.charAt(0).toUpperCase() + item.slice(1),
                        )
                        .join(', ')
                    : socialMediaType
                    ? socialMediaType.charAt(0).toUpperCase() +
                      socialMediaType.slice(1)
                    : '') +
                  (subtype === 'userposts' || subtype === 'manual_users'
                    ? ' User Account '
                    : subtype === 'userhashtags' ||
                      subtype === 'manual_hashtags'
                    ? ' User Hashtag '
                    : subtype === 'manual_tags'
                    ? ' User Tag '
                    : subtype === 'keywordposts'
                    ? ' Keywords '
                    : '') +
                  (subtype ? ' - ' : '') +
                  (ChatgptData.title !== undefined
                    ? ' "' + ChatgptData.title + '" '
                    : '') +
                  ' data - "' +
                  (SearchObject?.updatedDays || SearchObject?.days
                    ? (SearchObject?.updatedDays || SearchObject?.days) + ' days'
                    : SearchObject?.startDate && SearchObject?.endDate
                    ? SearchObject.startDate + ' to ' + SearchObject.endDate
                    : 'undefined') +
                  '"' +
                  (SearchObject?.interval !== undefined
                    ? ' by ' + SearchObject.interval
                    : '')}
            </p>

            {/* <div className="flex justify-center items-center"> */}
            {/* <button title="Disclaimer" onClick={() => setmodal(true)}>
              <FcDisclaimer className="text-lg" />
            </button> */}
            {/* <button
            title="Open Chat History in omniO AI Assistant Page"
            alt="Default Prompt"
            className="w-[30px] h-[30px] rounded-full flex items-center justify-center mx-2"
            onClick={() => {
              navigate('/haix-genai/summary', {
                state: {
                  message: summary,
                  pillname: ChatgptData?.title,
                  socialMediaType,
                  handler: mainSearchTerm,
                  ChatgptData,
                  chartData: ChatgptData.excelData.slice(0, 40),
                },
              });
              setSummaryStatus(false);
              handleSummarizeBtn();
            }}
          >
            <GoLinkExternal className="text-[16px] text-green-600" />
          </button> */}
            <button
              title="Close"
              onClick={() => setSummaryStatus(false)}
              className="mx-4"
            >
              <AiOutlineClose color="#ff0000" />
            </button>
            {/* </div> */}
          </div>
          <div className="overflow-x-auto overflow-y-auto h-auto  md:h-[50vh]">
            {!isLoading &&
              summary.reverse().map((line, index) => {
                return (
                  <div key={index} className="border-b-2 my-2 mx-4">
                    <div className="mt-2 flex items-center justify-between">
                      <span className="font-bold">
                        Summary by omniO AI Assistant:{' '}
                      </span>
                      <div className="flex items-center gap-2">
                        {line?.cached && (
                          <span className="text-xs font-normal text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                            Saved{line?.savedAt ? ` · ${new Date(line.savedAt).toLocaleString()}` : ''}
                          </span>
                        )}
                        {line?.cached && index === 0 && (
                          <button
                            type="button"
                            onClick={handleRegenerate}
                            disabled={isLoading}
                            className="text-xs text-primary hover:underline disabled:opacity-50"
                            title="Run this chart again instead of reusing the saved answer"
                          >
                            Regenerate
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="mt-2 mb-3">{renderMarkdown(line?.content)}</div>
                  </div>
                );
              })}
            {isLoading && <LoaderBoxes message="Fetching" />}
            {!isLoading && errorMessage && (
              <div className="mx-4 my-4 flex items-center justify-between gap-3 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                <span>{errorMessage}</span>
                <button
                  type="button"
                  onClick={handleRegenerate}
                  className="shrink-0 text-xs font-medium underline"
                >
                  Try again
                </button>
              </div>
            )}
          </div>
          <div className="mx-4 my-2 flex items-center">
            For more details Analysis -
            <button
              title="Open Chat History in omniO AI Assistant"
              onClick={() => {
                setSidebarStatus(true);
                setSummaryStatus(false);
              }}
              className="underline text-secondary bottom-0"
            >
              <GoLinkExternal className="text-[16px] text-green-600" />
            </button>
          </div>
        </div>
      </SummaryDialog>
    </Draggable>
  );
};

export default memo(ChatgptSummary);
